import { Controller } from "@hotwired/stimulus"

// Filtro de texto sobre las filas del diccionario de claves (/diccionario/:ruta).
// Oculta las filas cuyo texto no contiene la consulta, las secciones que se
// quedan vacías, y actualiza el contador de claves visibles.
export default class extends Controller {
  static targets = ["input", "row", "section", "count", "empty"]

  apply() {
    const q = this.inputTarget.value.trim().toLowerCase()
    let visible = 0

    this.rowTargets.forEach((row) => {
      const match = q === "" || row.textContent.toLowerCase().includes(q)
      row.hidden = !match
      if (match) visible++
    })

    this.sectionTargets.forEach((section) => {
      const any = Array.from(section.querySelectorAll("tbody tr")).some((r) => !r.hidden)
      section.hidden = !any
    })

    if (this.hasCountTarget) this.countTarget.textContent = visible.toLocaleString("es-PA")
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
  }
}
